import { mtechnavi } from '~/shared/libs/clientsdk';
import { AppSaveWorker } from '..';

export interface generateAiWords {
  actionName: 'generateAiWords';
  request: mtechnavi.api.analysis.IGenerateAiWordsRequest;
}

export const generateAiWords = async (
  worker: AppSaveWorker,
  req: mtechnavi.api.analysis.IGenerateAiWordsRequest
) => {
  const execMethodName =
    'mtechnavi.api.analysis.SearchCompanyService/GenerateAiWords';

  const result = await worker.invokeListRequest(execMethodName, {
    aiPrompt: req.aiPrompt,
  });
  return result;
};
